import { createSelector } from '@ngrx/store';
import { selectSmsVerificationFeatureState } from '@reducers/index';

/* istanbul ignore next  */
export const selectSmsVerificationBookingVerified = createSelector(
  selectSmsVerificationFeatureState,
  (state) => state.bookingVerified,
);
